<template>
  <!-- Educational header for the profile dropdown: full-width institution logo
       above the name + "educational account" label. Renders nothing for
       non-students. -->
  <div v-if="institution" class="student-institution-badge tw-text-center">
    <img
      v-if="institution.logo_url"
      :src="institution.logo_url"
      :alt="institutionName"
      class="tw-w-full tw-h-12 tw-object-contain tw-mb-2"
    />
    <div class="tw-text-sm tw-font-semibold tw-text-gray-800 tw-leading-tight">
      {{ institutionName }}
    </div>
    <div class="tw-text-xs tw-font-medium tw-text-primary tw-leading-tight tw-mt-0.5">
      {{ $t('student.label') }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'StudentInstitutionBadge',
  computed: {
    ...mapState({ user: (state) => state.auth.currentUser }),
    institution() {
      return this.user && this.user.institution ? this.user.institution : null;
    },
    institutionName() {
      return this.institution ? this.institution.name : '';
    },
  },
};
</script>
